<!-- Splash screen — shown until first navigation resolves + view is painted -->
@if (loader()) {
  <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-syn-surface">
    <app-entry></app-entry>
  </div>
}

@if (!loader() && !authService.authenticated && isLoginPage()) {
  <div>
    <app-login></app-login>
  </div>
}

@if (!loader() && !authService.authenticated && isPasswordForgotPage()) {
  <div>
    <app-password-forget></app-password-forget>
  </div>
}

@if (!loader() && !authService.authenticated && isPasswordResetPage()) {
  <div>
    <app-password-reset></app-password-reset>
  </div>
}

@if (!loader() && authService.authenticated) {
  <div class="flex flex-col h-screen overflow-hidden">

    <!-- Top Header (breadcrumb lives inside it via navigation slot) -->
    <application-header #header class="z-50 shrink-0"></application-header>

    <div class="flex flex-1 overflow-hidden relative min-h-0">

      <!-- Sidebar -->
      <app-sidebar
        #sideNav
        (onHide)="handleSideNavHide()"
        (onShow)="handleSideNavShow()"
        [open]="isSideNavOpen()"
        class="h-full"
      ></app-sidebar>

      <!-- Content Area -->
      <div class="flex-1 flex flex-col overflow-hidden min-h-0">
        <main class="flex-1 flex flex-col px-5 py-4 overflow-hidden min-h-0">

          <!-- Main Content -->
          <div class="flex-1 flex flex-col min-h-0 relative overflow-hidden">
            @if (pageHeader.headline()) {
              <h1 class="shrink-0 text-2xl font-bold mb-4 tracking-tight text-syn-color-neutral-900" style="color: var(--syn-color-neutral-900)">
                {{ pageHeader.headline() }}
              </h1>
            }
            <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
              <router-outlet />
            </div>
          </div>

        </main>
      </div>
    </div>
  </div>
}

<!-- Core service hosts -->
<app-drawer-host></app-drawer-host>
<app-dialog-host></app-dialog-host>
<app-modal-host></app-modal-host>
